/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditornextweek3Inputs */

const en_menueditornextweek3 = /** @type {(inputs: Menueditornextweek3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One week later`)
};

const de_menueditornextweek3 = /** @type {(inputs: Menueditornextweek3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Woche später`)
};

/**
* | output |
* | --- |
* | "One week later" |
*
* @param {Menueditornextweek3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditornextweek3 = /** @type {((inputs?: Menueditornextweek3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditornextweek3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditornextweek3(inputs)
	return de_menueditornextweek3(inputs)
});
export { menueditornextweek3 as "menuEditorNextWeek" }